import React, { useMemo } from 'react';
import moment from 'moment';
import classnames from 'classnames';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';

import './styles.scss';

export const TimeFilter = ({ competitionGames, routePrefix }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const {
    regionAlias, compId, gameId, sportType,
  } = useParams();

  const timesList = useMemo(() => [
    {
      value: '',
      label: 'All',
    },
    ...competitionGames.filter((game) => (game.start_ts >= moment().unix())).map((game) => ({
      label: moment.unix(game.start_ts).format('HH:mm'),
      value: game.id,
    })),
  ], [competitionGames]);

  const onChangeGame = (id) => navigate(`${routePrefix}/racings/${sportType}/upComing/${regionAlias}/${compId}/${id}?${searchParams.toString()}`);

  return (
    <div className="time-filter-container">
      {timesList.map((item) => (
        <div
          key={item.value}
          className={classnames('time-item', {
            active: gameId ? item.value === +gameId : !item.value,
          })}
          onClick={() => onChangeGame(item.value)}
        >
          <span>{item.label}</span>
        </div>
      ))}
    </div>
  );
};
